<script>
export default {
  name: "resetPassword",
  methods: {
    async updatePassword() {
      await this.$A.UserService.UpdatePassword(
          this.curPass,
          this.pass,
          this.passConfirm
      );
      this.curPass = "";
      this.pass = "";
      this.passConfirm = "";
    },
  },
  mounted() {
  },
  data: function () {
    return {
      curPass: "",
      pass: "",
      passConfirm: "",
    };
  },
};
</script>

<template>
  <div class="settings-card">
    <div class="card-head">
      <div class="card-head-title">Manage Password</div>
      <div class="card-head-subtitle">Use a strong password you don't use anywhere else.</div>
    </div>
    <div class="card-body">
      <div class="field">
        <label class="field-label" for="currentPassword">Your Current Password</label>
        <input
            id="currentPassword"
            type="password"
            name="currentPassword"
            class="text-input"
            v-model="curPass"
        />
      </div>
      <div class="field">
        <label class="field-label" for="newPassword">Your New Password</label>
        <input
            id="newPassword"
            type="password"
            name="newPassword"
            class="text-input"
            v-model="pass"
        />
      </div>
      <div class="field">
        <label class="field-label" for="confirmNewPassword">Confirm Your New Password</label>
        <input
            id="confirmNewPassword"
            type="password"
            name="confirmNewPassword"
            class="text-input"
            v-model="passConfirm"
        />
      </div>
    </div>
    <div class="card-foot">
      <a class="primary-btn" @click="updatePassword">Update</a>
    </div>
  </div>
</template>

<style scoped>
.settings-card {
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.04), 0 8px 24px -16px rgba(8, 11, 13, 0.1);
}
.card-head {
  padding: 14px 20px;
  background: #fbfbfc;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px 12px 0 0;
}
.card-head-title {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}
.card-head-subtitle {
  margin-top: 1px;
  font-size: 12.5px;
  font-weight: 400;
  color: #6b7280;
}
.card-body {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 20px;
  max-width: 440px;
}
.card-foot {
  display: flex;
  justify-content: flex-end;
  padding: 12px 20px;
  background: #fbfbfc;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 0 0 12px 12px;
}
.field-label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  color: #6b7280;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-bottom: 6px;
}
.text-input {
  width: 100%;
  height: 38px;
  padding: 0 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 13px;
  color: #1f2937;
  background: #fff;
  outline: none;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.05);
  transition: border-color 120ms ease, box-shadow 120ms ease;
}
.text-input:focus {
  border-color: #019256;
  box-shadow: 0 0 0 3px rgba(1, 146, 86, 0.12);
}
.primary-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 18px;
  background: #019256;
  color: #fff;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 120ms ease;
}
.primary-btn:hover {
  background: #017a48;
  color: #fff;
  text-decoration: none;
}
@media (max-width: 575px) {
  .primary-btn {
    width: 100%;
  }
}
</style>
